import { render, staticRenderFns } from "./LayoutContainer.vue?vue&type=template&id=1a56843e&scoped=true"
import script from "./LayoutContainer.vue?vue&type=script&lang=js"
export * from "./LayoutContainer.vue?vue&type=script&lang=js"
import style0 from "./LayoutContainer.vue?vue&type=style&index=0&id=1a56843e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56843e",
  null
  
)

export default component.exports